import OWContainer from 'styles/styled-components/ow-container';
import { CompanyForm } from '../components/company-form';
import useController from '../controllers/edit-company-controller';
import { Spinner } from 'components/design';

export const EditCompanyRoute = () => {
    const {
        formData,
        companyOwners,
        onChange,
        onSubmit,
        onCancel,
        dataChanged,
        isLoading,
        isEditCompanyLoading,
        errors,
        cities,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <CompanyForm
                    formData={formData}
                    companyOwners={companyOwners}
                    cities={cities}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    isSaveLoading={isEditCompanyLoading}
                    errors={errors}
                    disableSubmit={!dataChanged}
                />
            )}
        </OWContainer>
    );
};
